import type {RootState} from '@/state/store';

export const selectMarketCode = (state: RootState) => state.appSlice.marketCode;
export const selectLanguageCode = (state: RootState) => state.appSlice.languageCode;
export const selectIsInitialized = (state: RootState) => state.appSlice.isInitialized;
export const selectPadding = (state: RootState) => state.appSlice.padding;
